import { Form } from "@redriver/cinnamon-mui";
import { clientTypesLookup } from "modules/lookups";

const ClientTypeDropdown = (props) => (
  <Form.Dropdown search lookup={clientTypesLookup} {...props} />
);

export default ClientTypeDropdown;
